// System Control Block Validator
import React, { useState, useEffect } from 'react';
import './SystemBlockValidator.scss';
import checklist from '../../data/systemBlockValidator.json';

type ChecklistItem = {
  title: string;
  regex: string;
  recommendation: string;
};

const SystemBlockValidator: React.FC = () => {
  const [scbText, setScbText] = useState('');
  const [fileName, setFileName] = useState<string | null>(null);
  const [report, setReport] = useState<any[]>([]);

  const handleFileUpload = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = (event) => {
      const text = event.target?.result?.toString() || '';
      setScbText(text);
      setFileName(file.name);
    };
    reader.readAsText(file);
  };

  useEffect(() => {
    if (!scbText) return;

    const results = (checklist as ChecklistItem[]).map((item) => {
      const passed = new RegExp(item.regex, 'i').test(scbText);
      return {
        ...item,
        passed,
      };
    });

    setReport(results);
  }, [scbText]);

  return (
    <div className="validator-container">
      <h1>✅ System Block Validator</h1>

      <label className="file-label">
        Load SCB File (.md or .txt):
        <input type="file" accept=".md,.txt" onChange={handleFileUpload} />
      </label>

      {fileName && <p className="filename">Loaded: <strong>{fileName}</strong></p>}

      {report.length > 0 && (
        <div className="report">
          <h2>📋 Validation Report</h2>
          <ul>
            {report.map((item, idx) => (
              <li key={idx} className={item.passed ? 'pass' : 'fail'}>
                <strong>{item.title}:</strong> {item.passed ? '✔ Passed' : '❌ Missing'}
                {!item.passed && (
                  <div className="recommendation">
                    <em>Recommendation:</em> {item.recommendation}
                  </div>
                )}
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default SystemBlockValidator;
